export interface PropertyDefinition {
    readonly key: string
    readonly optional: boolean
    readonly converter: PropertyTypeConverter<PropertyType>
}

export type PropertyType = string | number | boolean;
export type Properties = { [key: string]: PropertyType };

export interface PropertyTypeConverter<T extends PropertyType> {
    convert(value: unknown): T
}

export const BOOLEAN = new class implements PropertyTypeConverter<boolean> {
    convert(value: unknown): boolean {
        if (typeof value === 'boolean') {
            return value;
        }
        else if (typeof value === "string") {
            return value.toLowerCase() === "true";
        }
        throw new Error("Cannot convert value to boolean: " + value);
    }
};

export const STRING = new class implements PropertyTypeConverter<string> {
    convert(value: unknown): string {
        if (value === undefined) {
            throw new Error("Cannot convert undefined ");
        }
        return String(value);
    }
}

export const NUMBER = new class implements PropertyTypeConverter<number> {
    convert(value: unknown): number {
        if (value === undefined) {
            throw new Error("Cannot convert undefined ");
        }
        if (typeof value === "object") {
            throw new Error("Cannot convert object/array to number: " + value);
        }
        return Number(value);
    }
}

export function property<T extends PropertyType>(name: string, converter: PropertyTypeConverter<T>): PropertyDefinition {
    return {key: name, optional: true, converter: converter};
}
